// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"793":"e130525a","1832":"59487272","2873":"9a4af30b"}[chunkId] + ".chunk.css";
};